export const ENDPOINT = 'https://dapi.kakao.com/v2/local/search/address.json'
export const REGION_ENDPOINT = 'https://dapi.kakao.com/v2/local/geo/coord2regioncode.json'
export const KEYWORD_ENDPOINT = 'https://dapi.kakao.com/v2/local/search/keyword.json'
export const PAGE_SIZE = 10
